import { Text } from '@mantine/core';
import { Button } from '@vrplatform/components';
import { EmptyViewWrapper } from '../../components';

/** A signed-in account without owner access to the portal's team. */
export const OwnerPortalAccessDenied = ({
  portalName,
  email,
  onSignOut,
}: {
  portalName: string;
  email: string | undefined;
  onSignOut: () => void;
}) => (
  <EmptyViewWrapper
    title="Owner access required"
    description={
      <>
        {email ? (
          <>
            You're signed in as{' '}
            <Text span fw={500} c="neutral.9">
              {email}
            </Text>
            , which doesn't have owner access to {portalName}.
          </>
        ) : (
          `This account doesn't have owner access to ${portalName}.`
        )}{' '}
        Sign out, then sign in with the email address your invitation was sent
        to.
      </>
    }
    actions={
      <Button variant="primary" onClick={onSignOut}>
        Sign out
      </Button>
    }
  />
);
